import { functionUrl } from '../config'
import * as types from '../constants/ActionTypes'

export const associateDeviceWithFlight = ({
  tenant,
  tournamentId,
  flightId,
  uid,
  secret,
}) => dispatch => {
  const actionProps = { tenant, tournamentId, flightId, authId: uid }
  dispatch({ type: types.DEVICE_AUTH_REQUEST, ...actionProps })

  fetch(functionUrl('pairDevice'), {
    method: 'POST',
    body: JSON.stringify({ ...actionProps, secret }),
    headers: {
      'content-type': 'application/json',
    },
  })
    .then(() => {
      dispatch({ type: types.DEVICE_AUTH_SUCCESS, ...actionProps })
    })
    .catch(error => {
      dispatch({ type: types.DEVICE_AUTH_FAILURE, ...actionProps, error })
    })
}



// WEBPACK FOOTER //
// ./src/actions/deviceAuth.ts